// src/components/roles/RoleWizard/WizardStep1.tsx
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { RoleWizardData } from '../../../types/role.types';

interface WizardStep1Props {
  formData: RoleWizardData;
  setFormData: React.Dispatch<React.SetStateAction<RoleWizardData>>;
  errors?: {
    name?: string;
    description?: string;
  };
}

const WizardStep1: React.FC<WizardStep1Props> = ({ formData, setFormData, errors }) => {
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      description: e.target.value,
    }));
  };

  return (
    <Box sx={{ py: 3 }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}>
        Información Básica
      </Typography>
      <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
        Define el nombre y descripción del nuevo rol
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* Nombre */}
        <TextField
          fullWidth
          required
          label="Nombre del Rol"
          name="name"
          value={formData.name}
          onChange={handleNameChange}
          error={!!errors?.name}
          helperText={
            errors?.name ||
            'Mínimo 3, máximo 50 caracteres. No puede empezar o terminar con espacios.'
          }
          placeholder="Ej: Editor, Viewer, Manager"
          InputLabelProps={{ shrink: true }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />

        {/* Descripción */}
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Descripción"
          name="description"
          value={formData.description}
          onChange={handleDescriptionChange}
          error={!!errors?.description}
          helperText={errors?.description || 'Descripción opcional del rol (máximo 500 caracteres)'}
          placeholder="Describe las responsabilidades y permisos de este rol..."
          InputLabelProps={{ shrink: true }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default WizardStep1;
